export default __webpack_public_path__ + "assets/images/coinflip-089df70c402154c2d409f288d0390832.svg";